<template>
  <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.64795 13.9563L17.5 5.10422L26.3521 13.9563" stroke="#292D32" stroke-width="1.27273" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M17.5 29.8958L17.5 5.352" stroke="#292D32" stroke-width="1.27273" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>